import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i2 from 'app-services-library';

class CustomReadonlyLabelValueLibraryService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getReadOnlyDataSourceValue(payload) {
        return this.httpClient.post(`/vd/formBuilder/form/property/value`, payload).pipe(map((response) => {
            if (response.status === 200 && response.data) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
}
CustomReadonlyLabelValueLibraryService.ɵfac = function CustomReadonlyLabelValueLibraryService_Factory(t) { return new (t || CustomReadonlyLabelValueLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
CustomReadonlyLabelValueLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomReadonlyLabelValueLibraryService, factory: CustomReadonlyLabelValueLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomReadonlyLabelValueLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class CustomReadonlyLabelValueLibraryComponent {
    constructor(customReadonlyLabelValueLibraryService, appServicesLibraryService) {
        this.customReadonlyLabelValueLibraryService = customReadonlyLabelValueLibraryService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.value = null;
        this.userType = sessionStorage.getItem('userTypeRole');
    }
    ngOnInit() {
        var _a, _b;
        this.value = null;
        this.employeeId = sessionStorage.getItem("loginEmployeeId");
        if (this.userType !== 'Platform' && ((_b = (_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.fbBeneficiaryPlaceholder)) {
            if (this.inputParams.properties.selectedDependents.includes('listId') && this.inputParams.properties.selectedDependents.includes('listPageFormId')) {
                const listId = 'idToGetDetails' in sessionStorage ? Number(sessionStorage.getItem('idToGetDetails')) : this.employeeId;
                //const listPageFormId = 'currentPageFormId' in sessionStorage ? Number(sessionStorage.getItem('currentPageFormId')) : 83;
                const listPageFormId = 'currentPageFormId' in sessionStorage ? Number(sessionStorage.getItem('currentPageFormId')) : (this.inputParams.name === "PhoneNumber" ? 83 : null);
                const isOnboardEmployee = listPageFormId === 83 ? false : undefined;
                if (listId && listPageFormId) {
                    this.customReadonlyLabelValueLibraryService.getReadOnlyDataSourceValue({
                        listId,
                        listPageFormId,
                        placeHolderId: this.inputParams.properties.fbBeneficiaryPlaceholder,
                        isOnboardEmployee
                    })
                        .pipe(take(1))
                        .subscribe(data => {
                        this.value = data !== null && data !== void 0 ? data : '--';
                    });
                }
            }
        }
        else if (this.userType == 'Platform') {
            this.value = 'Data source value';
        }
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
}
CustomReadonlyLabelValueLibraryComponent.ɵfac = function CustomReadonlyLabelValueLibraryComponent_Factory(t) { return new (t || CustomReadonlyLabelValueLibraryComponent)(i0.ɵɵdirectiveInject(CustomReadonlyLabelValueLibraryService), i0.ɵɵdirectiveInject(i2.AppServicesLibraryService)); };
CustomReadonlyLabelValueLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomReadonlyLabelValueLibraryComponent, selectors: [["lib-custom-readonly-label-value-library"]], inputs: { inputParams: "inputParams" }, decls: 5, vars: 2, consts: [[1, "form-group"], [1, "d-block"], [1, "common-bene-class-for-translation"], [1, "font-weight-600", 3, "innerHtml"]], template: function CustomReadonlyLabelValueLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "label", 1);
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "label", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.inputParams == null ? null : ctx.inputParams.label);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHtml", ctx.value, i0.ɵɵsanitizeHtml);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomReadonlyLabelValueLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-custom-readonly-label-value-library',
                templateUrl: './custom-readonly-label-value-library.component.html',
                styleUrls: ['./custom-readonly-label-value-library.component.scss']
            }]
    }], function () { return [{ type: CustomReadonlyLabelValueLibraryService }, { type: i2.AppServicesLibraryService }]; }, { inputParams: [{
            type: Input
        }] }); })();

class CustomReadonlyLabelValueLibraryModule {
}
CustomReadonlyLabelValueLibraryModule.ɵfac = function CustomReadonlyLabelValueLibraryModule_Factory(t) { return new (t || CustomReadonlyLabelValueLibraryModule)(); };
CustomReadonlyLabelValueLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomReadonlyLabelValueLibraryModule });
CustomReadonlyLabelValueLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomReadonlyLabelValueLibraryModule, { declarations: [CustomReadonlyLabelValueLibraryComponent], exports: [CustomReadonlyLabelValueLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomReadonlyLabelValueLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomReadonlyLabelValueLibraryComponent],
                imports: [],
                exports: [CustomReadonlyLabelValueLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-readonly-label-value-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomReadonlyLabelValueLibraryComponent, CustomReadonlyLabelValueLibraryModule, CustomReadonlyLabelValueLibraryService };
//# sourceMappingURL=custom-readonly-label-value-library.js.map
